import './navigation-drawer'
import './navigation-dropdown'
import './testimonial'
import './cookies'

/* eslint-disable no-undef */

// eslint-disable-next-line no-unused-vars
const swiper = new Swiper('.swiper-testimonial', {
  // Optional parameters
  // direction: 'vertical',
  loop: false,
  centeredSlides: true,
  slidesPerView: 1,
  spaceBetween: 32,

  // If we need pagination
  // pagination: {
  //   el: '.swiper-pagination'
  // },

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-testimonial-next-button',
    prevEl: '.swiper-testimonial-prev-button',
  },

  // And if we need scrollbar
  // scrollbar: {
  //   el: '.swiper-scrollbar'
  // }
  breakpoints: {
    1200: {
      slidesPerView: 1.2,
    },
  },
})

const productPowerInsightsEl = document.querySelector('.product__power-insight')
productPowerInsightsEl
  .querySelectorAll('.product__power-insight--tab')
  .forEach((tabElement) => {
    tabElement.addEventListener('click', () => {
      productPowerInsightsEl
        .querySelectorAll('.product__power-insight--tab')
        .forEach((el) => {
          el.classList.remove('active')
        })

      productPowerInsightsEl
        .querySelectorAll('.product__power-insight--content-item')
        .forEach((el) => {
          el.style.display = 'none'

          if (
            tabElement.getAttribute('data-tab') === el.getAttribute('data-tab')
          ) {
            el.style.display = 'flex'
          }
        })

      console.log(tabElement.getAttribute('data-tab'))

      tabElement.classList.add('active')
    })
  })

const preHeadingIcon = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="32" height="32" rx="16" fill="#1DCA5D"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.8337 14.2283C13.2713 13.8583 14.3337 12.5532 14.3337 11C14.3337 9.15905 12.8413 7.66667 11.0003 7.66667C9.15938 7.66667 7.66699 9.15905 7.66699 11C7.66699 12.5532 8.7293 13.8583 10.167 14.2283V23.5C10.167 23.9602 10.5401 24.3333 11.0003 24.3333C11.4606 24.3333 11.8337 23.9602 11.8337 23.5V14.2283Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M17.667 21C17.667 19.4468 18.7293 18.1417 20.167 17.7717V12.6667C20.167 12.4457 20.0792 12.2337 19.9229 12.0774C19.7666 11.9211 19.5547 11.8333 19.3337 11.8333H16.8337C16.3734 11.8333 16.0003 11.4602 16.0003 11C16.0003 10.5398 16.3734 10.1667 16.8337 10.1667H19.3337C19.9967 10.1667 20.6326 10.4301 21.1014 10.8989C21.5703 11.3677 21.8337 12.0036 21.8337 12.6667V17.7717C23.2713 18.1417 24.3337 19.4468 24.3337 21C24.3337 22.8409 22.8413 24.3333 21.0003 24.3333C19.1594 24.3333 17.667 22.8409 17.667 21Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M17.6667 21C17.6667 19.4468 18.729 18.1417 20.1667 17.7717V12.6667C20.1667 12.4457 20.0789 12.2337 19.9226 12.0774C19.7663 11.9211 19.5543 11.8333 19.3333 11.8333H16.8333C16.3731 11.8333 16 11.4602 16 11C16 10.5398 16.3731 10.1667 16.8333 10.1667H19.3333C19.9964 10.1667 20.6323 10.4301 21.1011 10.8989C21.5699 11.3677 21.8333 12.0036 21.8333 12.6667V17.7717C23.271 18.1417 24.3333 19.4468 24.3333 21C24.3333 22.8409 22.8409 24.3333 21 24.3333C19.1591 24.3333 17.6667 22.8409 17.6667 21Z" fill="#77DF9E"/>
</svg>`

document.querySelector(
  '.apps__power-insight--left-preHeading-icon',
).innerHTML += preHeadingIcon
document.querySelector(
  '.testimonial-slider-preHeading .services__icon',
).innerHTML += preHeadingIcon
document.querySelector('.faq__feature-consulting--preHeading-icon').innerHTML +=
  preHeadingIcon

// Arrow Up Icon Button
const arrowUpIcon = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.83301 14.1667L14.1663 5.83334M14.1663 5.83334H5.83301M14.1663 5.83334V14.1667" stroke="#05A6F0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

// document.querySelector('.btn-learn-more').innerHTML += arrowUpIcon
document.querySelector('.btn.btn-book-demo').innerHTML += arrowUpIcon

// FAQ
document.querySelectorAll('.faq__feature-consulting--faqItem').forEach((el) => {
  el.querySelector('.faq__feature-consulting--faqItem-header').addEventListener(
    'click',
    () => {
      if (el.classList.contains('active')) {
        el.classList.remove('active')
      } else {
        document
          .querySelectorAll('.faq__feature-consulting--faqItem')
          .forEach((el2) => {
            el2.classList.remove('active')
          })

        el.classList.add('active')
      }
    },
  )
})

const chevronDownIcon = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 4.5L6 7.5L9 4.5" stroke="#94A3B8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

document.querySelectorAll('.link-item .arrow-down').forEach((el) => {
  el.innerHTML += chevronDownIcon
})

const hamburgerIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 12H21M3 6H21M3 18H21" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

document.querySelector('.btn-hamburger').innerHTML += hamburgerIcon

// Create the observer like the examples above
const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add('animate__fadeInUp')
    }

    // entry.target.classList.remove('animate__animated')
  })
})

// Get multiple elements instead of a single one using "querySelectorAll"
const squares = document.querySelectorAll('.animated-js')
// Loop over the elements and add each one to the observer
squares.forEach((element) => observer.observe(element))

const dropdownProduct = document.querySelector(
  '[data-element="dropdown-product"]',
)
dropdownProduct
  .querySelector('[data-element="dropdown-btn"]')
  .addEventListener('click', (el) => {
    if (
      dropdownProduct
        .querySelector('[data-element="dropdown-content"]')
        .classList.contains('hide')
    ) {
      dropdownProduct
        .querySelector('[data-element="dropdown-content"]')
        .classList.remove('hide')
      dropdownProduct.querySelector(
        '[data-element="dropdown-btn-arrow"]',
      ).style.rotate = '180deg'
    } else {
      dropdownProduct
        .querySelector('[data-element="dropdown-content"]')
        .classList.add('hide')
      dropdownProduct.querySelector(
        '[data-element="dropdown-btn-arrow"]',
      ).style.rotate = '0deg'
    }
  })
dropdownProduct
  .querySelectorAll('[data-element="dropdown-btn-item"]')
  .forEach((elBtn) => {
    elBtn.addEventListener('click', (ev) => {
      const textSelection = elBtn.querySelector('p').textContent
      dropdownProduct.querySelector(
        '[data-element="dropdown-btn"] p',
      ).textContent = textSelection

      dropdownProduct
        .querySelector('[data-element="dropdown-content"]')
        .classList.add('hide')
      dropdownProduct.querySelector(
        '[data-element="dropdown-btn-arrow"]',
      ).style.rotate = '0deg'

      productPowerInsightsEl
        .querySelectorAll('.product__power-insight--content-item')
        .forEach((elContent) => {
          elContent.style.display = 'none'

          if (
            elBtn.getAttribute('data-select') ===
            elContent.getAttribute('data-tab')
          ) {
            elContent.style.display = 'flex'
          }
        })
    })
  })
